import { safeParseNullDefault } from 'shouldve-been-js';

class MemoTemplateTab {

    private _index: number;
    private _tabId: string;
    private _caption: string;

    public constructor(index: number, tabId: string, caption: string) {

        this._index = index;
        this._tabId = tabId;
        this._caption = caption;
    }

    public get index(): number {
        return this._index;
    }

    public set index(value: number) {
        this._index = value;
    }

    public get tabId(): string {
        return this._tabId;
    }

    public set tabId(value: string) {
        this._tabId = value;
    }

    public get caption(): string {
        return this._caption;
    }

    public set caption(value: string) {
        this._caption = value;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    public static fromJson(json: any): MemoTemplateTab | null {

        const index: number | null = safeParseNullDefault<number>(json?.index, 0);
        const tabId: string | null = safeParseNullDefault<string>(json?.tabId, '');
        const caption: string | null = safeParseNullDefault<string>(json?.caption, '');
        
        if (index === null || tabId === null || caption === null || tabId === '') {
            return null;
        }

        return new MemoTemplateTab(index, tabId, caption);
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    public static fromIndexedDB(object: any): MemoTemplateTab | null {

        const index: number | null = safeParseNullDefault<number>(object?._index, 0);
        const tabId: string | null = safeParseNullDefault<string>(object?._tabId, '');
        const caption: string | null = safeParseNullDefault<string>(object?._caption, '');
        
        if (index === null || tabId === null || caption === null || tabId === '') {
            return null;
        }

        return new MemoTemplateTab(index, tabId, caption);
    }
}

export default MemoTemplateTab;